import { forwardRef } from 'react';

// T119 — single source of truth for the text-field styling that was duplicated
// byte-for-byte as `inputCls` in ProfilePage + SettingsPage. `<textarea>` /
// `<select>` callers that can't use `<Input>` import the same `inputCls` const,
// so there's exactly one definition.
export const inputCls =
  'w-full rounded-md border border-slate-700 bg-slate-950/40 px-3 py-2 text-sm text-slate-100 focus:border-brand-500 focus:outline-none';

// forwardRef so modal callers that focus an input keep working.
const Input = forwardRef(function Input({ className = '', ...rest }, ref) {
  return <input ref={ref} className={`${inputCls} ${className}`.trim()} {...rest} />;
});

export default Input;
